export function useApi() {
  const config = useRuntimeConfig()
  const supabase = useSupabaseClient()

  const apiBase = import.meta.server
    ? (config.apiBaseInternal as string) || 'http://backend:8000'
    : config.public.apiBase || '/api'

  function buildUrl(path: string): string {
    if (/^https?:\/\//.test(path)) {
      return path
    }

    const normalizedBase = apiBase.endsWith('/') ? apiBase.slice(0, -1) : apiBase
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${normalizedBase}${normalizedPath}`
  }

  async function $api<T>(path: string, options: RequestInit = {}): Promise<T> {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string> || {}),
    }
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    const res = await fetch(buildUrl(path), {
      ...options,
      headers,
    })

    if (!res.ok) {
      const err = await res.json().catch(() => ({ detail: res.statusText }))
      throw new Error(err.detail || `API error ${res.status}`)
    }

    return res.json() as Promise<T>
  }

  return { $api }
}
